// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3 2H21V20H22V22H13V20H14V10H10V20H11V22H2V20H3V2ZM5.00079 20H7.99921L8 10H5L5.00079 20ZM19 10H16V20H19L19 10Z"}}]};

const Dam2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'dam-2-filled',
    ref,
    icon: element,
  },
));

Dam2FilledIcon.displayName = 'Dam2FilledIcon';

export default Dam2FilledIcon;
